import { QueryClient } from '@tanstack/react-query';
import { SystemPermission_Permission } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/user_pb';
import { LoaderFunctionArgs } from 'react-router';
import { listSystemUsersQuery } from '~/shared/api/systemUsers.queries';
import { requireUserPermissionForSystemId } from '~/shared/auth/auth-utils';
import { ResourceNameIdConverter } from '~/shared/models/ResourceNameIdConverter';
import { assertIsDefined } from '~/types/assert-type';
import { getSystemQuery } from '~/shared/api/system.queries';

export const systemUsersLoader =
  (queryClient: QueryClient) =>
  async ({ params, request }: LoaderFunctionArgs) => {
    const { systemId } = params;

    assertIsDefined(systemId);

    await requireUserPermissionForSystemId(
      queryClient,
      request,
      SystemPermission_Permission.USER_MANAGEMENT,
      systemId,
    );

    assertIsDefined(systemId);

    const [systemUsers, system] = await Promise.all([
      queryClient.ensureQueryData(
        listSystemUsersQuery(ResourceNameIdConverter.systemIdToName(systemId)),
      ),
      queryClient.ensureQueryData(getSystemQuery(systemId)),
    ]);

    return { systemUsers, system };
  };
